import { addPointInteger, capitalizarTexto } from 'vlcishared';
import { COLORS } from '../colors';
import { TEXTS_SEGURIDAD_DETAIL } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';


// Gráfica | Barras apiladas intervenciones mensuales
export const optionsEvolucionMensual = {
  color: Object.values(COLORS),
  grid: {
    left: '0',
    right: '5',
    bottom: '0',
    top: '50',
    containLabel: true,
  },
  title: {
    text: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('h1_intervenciones'),
    subtext: `${TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('evolucion_mensual')}`,
    top: '0',
    left: 'center',
    itemGap: 5,
    textStyle: {
      fontSize: 15,
      fontFamily: 'Montserrat',
      fontWeight: 400,
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 400,
      color: '#666',
    },
  },
  legend: {
    data: [],
    show: false,
  },
  toolbox: {
    show: true,
    right: '0',
    top: '0',
    emphasis: {
      iconStyle: {
        borderColor: '#ffcd00',
        textFill: '#666',
      },
    },
    feature: {
      saveAsImage: {
        title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('download'),
        textStyle: {
          fontSize: 6,
          fontFamily: 'Montserrat',
          fontWeight: 300,
        },
      },
    },
  },
  tooltip: {
    confine: true,
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
    },
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisTick: { show: false },
      boundaryGap: ['20%', '20%'],
      gridIndex: 0,
      offset: 0,
      axisLine: {
        lineStyle: {
          color: '#ccc',
        },
      },
      axisLabel: {
        show: true,
        interval: 'auto',
        textStyle: {
          fontFamily: 'Montserrat',
          fontSize: 10,
          color: '#333',
        },
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      gridIndex: 0,
      offset: 0,
      axisLabel: {
        textStyle: {
          fontSize: 10,
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
        formatter: (value) => addPointInteger(Math.round(value)),
      },
    },
  ],
  series: [
    {
      data: [],
      type: 'bar',
      barWidth: '60%',
    },
  ],
};

// Gráfica | Barra apilada franjas horarias
export const optionFranjaHoraria = {
  grid: {
    left: '1%',
    right: '1%',
    bottom: '0',
    top: '20',
    containLabel: true,
  },
  title: {   
    text: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('h1_intervenciones') + ' ' + TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('franja_horaria'),
    top: '0',
    left: 'center',
    itemGap: 5,
    textStyle: {
      fontSize: 12,
      fontFamily: 'Montserrat',
      fontWeight: 400,
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 400,
      color: '#666',
    },
  },
  legend: {show: false},
  xAxis: {
    type: 'category',
    splitLine: { show: false },
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { show: false },
  },
  yAxis: {
    type: 'value',
    splitLine: { show: false },
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { show: false },
  },
  series: [
    {
      barWidth: '110%',
      label: {
        show: true,
        position: ['0', '50%'],
        fontSize: 6,
        lineHeight: 9,
        align: 'left',
        textStyle: {
        },
      },
    },
  ],
  media: [
    { //maxHeight: 220,
      query: {
        minHeight: 220,
      },
      option: {
        grid: {
          top: '40',
        },
        title: {
          text: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('h1_intervenciones'),
          subtext: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('franja_horaria'),
          textStyle: {
            fontSize: 15,
          },
        },
        series: {
          label: {
            position: 'inside',
            textStyle: {
              fontSize: 13,
              lineHeight: 16,
            },
          },
        },
      },
    },
  ],
};

// Gráfica | Tarta de Intervenciones totales Nivel 1
export const optionIntervencionesTipo = {
  color: Object.values(COLORS),
  grid: {
    left: '0',
    right: '0',
    bottom: '0',
    top: '50',
    containLabel: true,
  },
  title: {
    text: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get(
      'intervenciones_totales',
    ),
    subtext: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('tipologia_nivel_1'),
    top: '0',
    left: 'center',
    itemGap: 5,
    textStyle: {
      fontSize: 15,
      fontFamily: 'Montserrat',
      fontWeight: 400,
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 400,
      color: '#666',
    },
  },
  legend: {
    orient: 'vertical',
    top: 'bottom',
    left: 'left',
    itemGap: 5,
    itemHeight: '9',
    selectedMode: true,
    textStyle: {
      fontSize: 9,
      lineHeight: 9,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: '#666',
    },
  },
  toolbox: {
    show: true,
    right: '0',
    top: '0',
    emphasis: {
      iconStyle: {
        borderColor: '#ffcd00',
        textFill: '#666',
      },
    },
    feature: {
      saveAsImage: {
        title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('download'),
        textStyle: {
          fontSize: 6,
          fontFamily: 'Montserrat',
          fontWeight: 300,
        },
      },
      restore: {
        title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('reset'),
        textStyle: {
          fontSize: 6,
          fontFamily: 'Montserrat',
          fontWeight: 300,
        },
      },
    },
  },
  tooltip: {
    trigger: 'item',
    confine: true,
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
    },
    formatter: function (param) {
      return (
        `<b style="color: #666;">${capitalizarTexto(param.name)}</b><br />` +
        `${addPointInteger(param.value)} ` +
        TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('intervenciones')
      );
    },
  },
  series: [
    {
      data: [],
      type: 'pie',
      radius: '40%',
      center: ['70%', '60%'],
      startAngle: 20,
      label: {
        show: true,
        textStyle: {
          fontFamily: 'Montserrat',
          fontSize: 10,
          lineHeight: 12,
        },
        formatter(param) {
          return `${capitalizarTexto(param.name)}\n${addPointInteger(
            param.percent,
          )}%`;
        },
        distanceToLabelLine: 3,
      },
      labelLine: {
        show: true,
        length: 5,
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  ],
  media: [
    {
      //minHeight: 195
      query: {
        minHeight: 195,
      },
      option: {
        legend: {
          orient: 'horizontal',
          bottom: '0',
          left: '0',
        },
        series: {
          center: ['50%', '50%'],
          startAngle: 0,
          label: {
            show: true,
            textStyle: {
              fontSize: 12,
              lineHeight: 14,
            },
            distanceToLabelLine: 5,
          },
          labelLine: {
            show: true,
            length: 5,
          },
          emphasis: {
            label: {
              show: true,
            },
          },
        },
      },
    },
    {
      //minHeight 195 minWidth 635
      query: {
        minHeight: 195,
        minWidth: 435,
      },
      option: {
        legend: { show: false },
        series: {
          radius: '45%',
          center: ['50%', '60%'],
          startAngle: 20,
          label: {
            show: true,
            textStyle: {
              fontSize: 10,
              lineHeight: 14,
            },
            formatter(param) {
              return `${param.name}\n${addPointInteger(param.percent)}%`;
            },
            distanceToLabelLine: 5,
          },
          labelLine: {
            show: true,
            length: 15,
          },
          emphasis: {
            label: {
              show: true,
            },
          },
        },
      },
    },
    {
      //minHeight: 320,
      query: {
        minHeight: 320,
      },
      option: {
        series: {
          center: ['50%', '55%'],
        },
      },
    },
    {
      //minWidth: 630,
      query: {
        minWidth: 630,
      },
      option: {
        series: {
          label: {
            show: true,
            textStyle: {
              fontSize: 13,
              lineHeight: 15,
            },
          },
        },
      },
    },
  ],
};